import { OgpApiService } from './ogp-api-service';
import { GetWorkerProfileResponse } from './worker-service.types';

export class WorkerService {
  constructor(private readonly ogpApiService: OgpApiService) {}

  public getPartnerWorkerProfile = async (workerId: string): Promise<GetWorkerProfileResponse> => {
    const result = await this.ogpApiService.get<GetWorkerProfileResponse>({
      path: `workers/${workerId}/profile`,
    });

    return result;
  };
}
